// 기존 사용자 키 배치 안내(레인 C, docs/PC-WINDOWS-PRD.md 4.1절): 진행 기록이 있는 기기는 지금 배치(액션식)를 유지하므로,
// 마을에 처음 들어왔을 때 화면 위쪽 가장자리 띠로 "설정에서 PC RPG식으로 바꿀 수 있어요"를 한 번만 알린다(6초 뒤 사라짐, 닫기 단추).
// 플레이 중앙을 가리지 않는 얇은 띠. 터치 전용 기기(coarse 포인터 + hover 없음)는 보이지 않고 바로 본 것으로 처리한다.
import { Scene, type GameView } from '../shared/types';
import { keymap, KEY_PRESET_NAME } from '../shared/keymap';
import { C, FONT, el } from './dom';

/** 터치 전용 기기인가(순수 판정 — 시험용) */
export function isTouchOnly(coarse: boolean, hover: boolean): boolean { return coarse && !hover; }
/** 띠를 보일 수 있는가(순수): 아직 안 봤고, 지금 배치가 PC RPG식이 아니고, 마을이다 */
export function shouldShowKeyHint(hinted: boolean, preset: string, scene: number): boolean {
  return !hinted && preset !== 'rpg' && scene === Scene.Village;
}

const SHOW_MS = 6000;

export class KeymapHint {
  private box: HTMLDivElement | null = null;
  private timer = 0;
  private done = false;

  constructor(private readonly parent: HTMLElement, private readonly view: GameView, touchOnly?: boolean) {
    let only = touchOnly === true;
    try {
      if (typeof matchMedia === 'function') only = only || isTouchOnly(matchMedia('(pointer: coarse)').matches, matchMedia('(hover: hover)').matches);
    } catch { /* 판별 불가: 그대로 */ }
    if (keymap.hinted) this.done = true;
    else if (only) { this.done = true; keymap.markHinted(); }
  }

  /** 매 프레임 호출되지만 상태 확인만 한다(DOM은 처음 보일 때 한 번 만든다) */
  update(): void {
    if (this.done) return;
    if (!shouldShowKeyHint(keymap.hinted, keymap.preset, this.view.flow.scene)) {
      if (keymap.hinted) this.done = true; // 설정에서 바꾸는 등으로 이미 본 것으로 처리됨
      return;
    }
    this.show();
  }

  private show(): void {
    this.done = true;
    keymap.markHinted();
    const box = el('div', 'position:absolute;left:50%;top:6px;transform:translateX(-50%);z-index:30;max-width:calc(var(--dh-w,100vw) - 24px);box-sizing:border-box;display:flex;align-items:center;gap:10px;' +
      'padding:6px 8px 6px 14px;border-radius:999px;background:rgba(10,14,28,.88);border:1px solid rgba(242,193,78,.6);box-shadow:0 2px 8px rgba(0,0,0,.5);pointer-events:none;font:700 12px/1.3 ' + FONT + ';color:#e8ecf8;word-break:keep-all;', this.parent);
    box.dataset.testid = 'keymap-hint';
    box.setAttribute('role', 'status');
    el('span', '', box, '설정에서 ' + KEY_PRESET_NAME.rpg + ' 키 배치(K 스킬 창 · C 스탯 창)로 바꿀 수 있어요');
    const x = el('button', 'pointer-events:auto;cursor:pointer;flex:0 0 auto;min-width:28px;min-height:28px;border-radius:50%;border:1px solid ' + C.gold + ';background:#1A2238;color:' + C.gold + ';font:800 13px ' + FONT + ';', box, '✕');
    x.type = 'button';
    x.setAttribute('aria-label', '안내 닫기');
    x.dataset.testid = 'keymap-hint-close';
    x.addEventListener('click', () => this.hide());
    // 마우스로 눌러도 게임 입력 포커스를 가져가지 않는다
    x.addEventListener('pointerdown', (e) => e.preventDefault());
    this.box = box;
    this.timer = window.setTimeout(() => this.hide(), SHOW_MS);
  }

  private hide(): void {
    window.clearTimeout(this.timer);
    this.box?.remove();
    this.box = null;
  }
}
